import React from "react";
import Skins from "../_data/Skins.js";

class OnboardingMember extends React.Component {
  props: {
    showLaptop: boolean
  };

  render() {
    const skin = Skins()[this.props.skinId];

    const characterContainerStyle = {
      display: "block",
      width: "15em",
      height: "15em",
      position: "relative",
      margin: "0 auto"
    };
    const characterStyle = {
      position: "absolute",
      left: 0,
      top: 0,
      width: "100%",
      display: "block"
    };
    const laptopStyle = {
      position: "absolute",

      left: "3.9em",
      top: "7em",
      width: "7em",
      display: "block"
    };

    return (
      <div style={characterContainerStyle}>
        <img
          style={characterStyle}
          src="/images/misc/shadow.svg"
          alt="Shadow"
        />
        <img style={characterStyle} src={skin.frontViewSrc} alt={"Character"} />

        {this.props.showLaptop
          ? <img
              style={laptopStyle}
              src="/images/misc/laptop-back.svg"
              alt={"Laptop"}
            />
          : null}
      </div>
    );
  }
}

export default OnboardingMember;



// WEBPACK FOOTER //
// ./src/b5-onboarding/OnboardingMember.js